import Vue from 'vue';
import NodeRSA from 'node-rsa';
import { PUBLIC_KEY_HEADER } from '../utils/api';

export default {
  formatter(unix) {
    const t = new Date(unix);
    // const zeroPad = num => (Array(2).join(0) + num).slice(-2);
    const zeroPad = (value, size) => (String(value).length < size ? zeroPad(`0${String(value)}`, size) : value);
    return `${zeroPad(t.getDate(), 2)}/${zeroPad(
      t.getMonth() + 1, 2,
    )}/${t.getFullYear()} ${zeroPad(t.getHours(), 2)}:${zeroPad(
      t.getMinutes(), 2,
    )}:${zeroPad(t.getSeconds(), 2)}`;
  },
  ipFormatter(ip) {
    const ipAddress = ip !== undefined
      ? ip
        .split(':')
        .slice(-1)
        .pop()
      : '';
    return ipAddress !== '1' ? ipAddress : 'localhost';
  },
  getUserPersistent() {
    if (Vue.prototype.$session) {
      if (!Vue.prototype.$session.get('ambgames-user-authenticate')) {
        return {
          user: {
            _id: null,
            username: null,
            role: null,
            source: null,
            avatar: null,
            profile: {
              name: null,
              mobile: null,
              lineId: null,
              gender: null,
              facebook: null,
              nickname: null,
            },
            wallet: {
              balance: null,
              buyIn: null,
              lastUpdate: null,
            },
            pt: {
              general: null,
              pg: null,
              ds: null,
            },
            level: null,
          },
          token: null,
        };
      }
      return JSON.parse(Vue.prototype.$session.get('ambgames-user-authenticate'));
    }
    return {
      user: {
        _id: null,
        username: null,
        role: null,
        source: null,
        avatar: null,
        profile: {
          name: null,
          mobile: null,
          lineId: null,
          gender: null,
          facebook: null,
          nickname: null,
        },
        wallet: {
          balance: null,
          buyIn: null,
          lastUpdate: null,
        },
        pt: {
          general: null,
          pg: null,
          ds: null,
        },
        level: null,
      },
      token: null,
    };
  },
  getUserBalance() {
    if (Vue.prototype.$session) {
      if (!Vue.prototype.$session.get('ambgames-user-authenticate')) {
        return 0;
      }
      return JSON.parse(Vue.prototype.$session.get('ambgames-user-authenticate'));
    }
    return Vue.prototype.$session;
  },
  setUserBalance(balance) {
    Vue.prototype.$session.set('ambgames-user-balance', balance);
  },
  currencyFormatter(balance) {
    const x = balance;
    if (x === 0) {
      return '0.00';
    } if (!x) {
      return x;
    }
    return x.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  },
  dateFormatter(unix) {
    const t = new Date(unix);
    const zeroPad = (value, size) => (String(value).length < size ? zeroPad(`0${String(value)}`, size) : value);
    return `${zeroPad(t.getFullYear(), 2)}-${zeroPad(t.getMonth() + 1, 2)}-${zeroPad(t.getDate(), 2)}`;
  },

  encryptSensitiveData(request) {
    const SENSITIVE_KEY = ['userId', 'role', 'subPassword', 'password'];
    for (let i = 0; i < Object.keys(request).length; i += 1) {
      const data = Object.keys(request)[i];
      if (SENSITIVE_KEY.includes(data)) {
        // eslint-disable-next-line no-param-reassign
        request = Object.assign(request, { [`${data}`]: this.encrypt(request[data]) });
      }
    }
    return request;
  },

  encrypt(data) {
    const key = new NodeRSA(PUBLIC_KEY_HEADER);
    return key.encrypt(data, 'base64');
  },
};
